import { useTranslation } from "@harea/component";
import { useDepartmentListQuery } from "./useTimeOffTypeQuery";

export const useDepartmentList = () => {

    const t = useTranslation()

    const { data: departments } = useDepartmentListQuery(true)

    const departmentList = (departments as any)?.data?.map(department => ({
        id: department.id,
        label: department?.designation,
        value: department.id
    })) || []

    return [
        {
            id: -1,
            label: t('std_all_department'),
            value: -1
        },
        ...departmentList
    ]
}